import { BoxProps, TextProps } from '@jfs/ui-new'
import { ViewStyle } from 'react-native'

const styles = {
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    w: '100%',
    zIndex: 8,
  } as BoxProps,
  subContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    w: '100%',
    height: 50,
    zIndex: 80,
    position: 'relative',
  } as BoxProps,
  wrap: {
    flexDirection: 'row',
    cursor: 'pointer',
    alignSelf: 'center',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    position: 'absolute',
    zIndex: 80,
    height: 50,
    flex: 1,
    width: '100%',
  } as BoxProps,
  input: {
    position: 'absolute',
    color: 'transparent',
    backgroundColor: 'transparent',
    width: '100%',
    height: 20,
    top: 0,
    left: 0,
    bottom: 0,
    zIndex: 100,
    outline: 'none',
    outlineColor: 'transparent',
    overflow: 'hidden',
    fontFamily: 'jiotype-medium',
  } as ViewStyle,
  display: (highlightBottom: boolean) =>
    ({
      borderBottomWidth: highlightBottom ? 2 : 1,
      borderBottomColor: highlightBottom ? 'PRIMARY' : 'BRAND_COLOR_GRAY_1',
      f: 1,
      height: 30,
      margin: 9,
      paddingBottom: 6,
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
    } as BoxProps),
  text: {
    fontSize: 24,
    color: 'BLACK_21',
    fontFamily: 'jioType-medium',
  } as TextProps,
  shadows: {
    // position: 'absolute',
    // left: -2,
    // top: -2,
    // bottom: -2,
    // right: -2,
    borderBottomColor: 'BLUE',
    borderBottomWidth: 2,
  } as unknown as BoxProps,
  dot: {
    height: 12,
    width: 12,
    borderRadius: 6,
    backgroundColor: 'BLACK',
  } as BoxProps,
  error: {
    borderBottomColor: 'ERROR',
  } as BoxProps,
}
export default styles
